/**
 * Les dix tables du Launcher, portees de V1 (`Bible MyTaki/launcher/index.html`).
 *
 * FICHIER ECRIT A LA MAIN, DESORMAIS, et c'est un changement a savoir.
 *
 * Il a ete GENERE une fois, depuis les fixtures du Launcher, et un test
 * verifiait table par table qu'il n'avait pas derive. Le Launcher a ete
 * supprime avec le chantier `studio-v0-lecture` : les fixtures et le test sont
 * partis avec lui, et l'en-tete a promis pendant deux chantiers un generateur
 * et un garde-fou qui n'existaient plus.
 *
 * Ce fichier est donc la SOURCE de ces tables, et rien ne le regenere. C'est
 * aussi la meilleure illustration de ce qui arrive a du code genere dans ce
 * depot : au bout de deux chantiers, il reste un fichier qui ment sur sa
 * provenance. A relire avant toute idee de generer du code ici.
 *
 * Ce sont des DONNEES, pas du comportement : aucune fonction ici.
 */

/**
 * LES FAMILLES DONT LE `type` N'EST PAS UNE CHAINE LIBRE.
 *
 * LE PATRON DU SOCLE EST « famille + type », et le type est declare par l'APP :
 * `products` accepte `matiere-premiere`, `compositions` accepte `recette`, et
 * ainsi de suite. UNE famille fait exception, `contacts`, dont le schema Zod
 * ferme l'enumeration (`person` / `organization`) parce que les Security Rules
 * s'appuient dessus.
 *
 * CE QUE CA COUTE QUAND PERSONNE NE LE DIT, mesure en recette le 10/09 : le
 * formulaire accepte un type invente sur `contacts`, le script ecrit l'app, le
 * semis pose les documents dans l'emulateur, et l'ecran de l'app refuse de les
 * lire (`Invalid enum value. Expected 'person' | 'organization'`). Tout est
 * vert, rien ne s'affiche, et la faute est a trois gestes en arriere.
 *
 * ELLE NE SE RECOPIE PAS : `scripts/check-app-entities.mjs` confronte cette
 * table aux `z.enum` de `@taki/data-model`, DANS LES DEUX SENS. Un jour ou une
 * famille ferme son type, ou ou `contacts` l'ouvre, la CI le dit.
 *
 * Ce module est SANS DEPENDANCE par contrat (`brief/INTERFACE.md`) : il tourne
 * dans le navigateur, il ne peut donc pas importer le data-model. D'ou la table,
 * et d'ou le garde-fou.
 */
export const TYPES_FERMES = {
  contacts: ['person', 'organization'],
};

/**
 * Les 58 familles generiques du socle.
 * L'id est celui de `@taki/data-model`, la description est celle que lit le fondateur.
 */
/*
 * L'ID D'UNE FAMILLE EST LE NOM DE SON REPOSITORY DANS LE SDK, celui que le
 * code appelle (`sdk.<id>.list()`) et que les fichiers de declaration ecrivent.
 *
 * LE SDK N'EST PAS REGULIER : la plupart de ses repositories sont au singulier
 * (`booking`, `workOrder`), deux sont au pluriel (`assets`, `contacts`). Cette
 * table doit suivre le SDK, pas une regle de grammaire : `asset` et `contact`
 * y ont figure au singulier, et le selecteur de famille du studio ecrivait donc
 * une famille qui n'existe nulle part, sur les DEUX familles les plus
 * utilisees du depot. Le garde-fou de `scripts/check-app-entities.mjs` verifie
 * desormais cette correspondance, table contre SDK.
 */
export const FAMILLES = [
  {"id":"absences","desc":"famille \"indisponibilité déclarée\""},
  {"id":"accessGrants","desc":"famille \"autorisation d'accès nominative et datée\""},
  {"id":"agreements","desc":"famille \"accord juridique formalisé\""},
  {"id":"assets","desc":"famille d'entités \"bien suivi\""},
  {"id":"attendances","desc":"famille \"présence (émargement)\""},
  {"id":"availabilities","desc":"famille \"règles de disponibilité\""},
  {"id":"bookings","desc":"famille \"créneau daté\""},
  {"id":"campaigns","desc":"famille \"action de communication groupée\""},
  {"id":"careRecords","desc":"famille \"entrée de suivi individualisé\""},
  {"id":"compositions","desc":"famille \"recette / nomenclature\""},
  {"id":"consents","desc":"famille \"consentement horodaté\""},
  {"id":"contacts","desc":"entité métier cœur"},
  {"id":"credentials","desc":"famille \"attestation à durée de validité\""},
  {"id":"credits","desc":"famille \"compteur nominatif de valeur ou d'unités\""},
  {"id":"custodies","desc":"famille \"prise en charge temporaire\""},
  {"id":"documents","desc":"famille \"fichier conservé\""},
  {"id":"donations","desc":"famille \"contribution volontaire sans contrepartie\""},
  {"id":"events","desc":"famille d'entités \"occurrence datée à capacité partagée\""},
  {"id":"expenses","desc":"famille \"frais engagé\""},
  {"id":"forms","desc":"famille \"formulaire\" (questionnaire)"},
  {"id":"groups","desc":"famille \"ensemble nommé de contacts\""},
  {"id":"incidents","desc":"famille \"événement dommageable\" (sinistre)"},
  {"id":"inspections","desc":"famille \"vérification structurée\""},
  {"id":"invoices","desc":"famille \"document de facturation\""},
  {"id":"listings","desc":"famille d'entités \"annonce\""},
  {"id":"loans","desc":"famille \"prêt d'un bien\""},
  {"id":"lots","desc":"famille \"sous-ensemble de stock tracé\""},
  {"id":"measurements","desc":"famille \"valeur chiffree horodatee\""},
  {"id":"member","desc":""},
  {"id":"messages","desc":"famille \"communication individuelle\""},
  {"id":"opportunities","desc":"famille \"piste commerciale\""},
  {"id":"orders","desc":"famille \"engagement commercial chiffré\""},
  {"id":"organization","desc":""},
  {"id":"payments","desc":"famille \"mouvement d'argent\" constaté entre un tiers et l'organisation (encaissement, acompte, caution restituable, remboursement), rattaché à ce qu'i"},
  {"id":"places","desc":"famille \"lieu physique identifié\" (interne ou externe)"},
  {"id":"policies","desc":"famille \"barème ou condition fixée une fois par l'organisation\""},
  {"id":"priceLists","desc":"famille \"règles de prix conditionnelles\""},
  {"id":"products","desc":"famille d'entités \"élément de catalogue\""},
  {"id":"projects","desc":"famille \"conteneur de travaux\""},
  {"id":"recurrences","desc":"famille \"plan récurrent\" (crée une fiche à un rythme donné)"},
  {"id":"registerSessions","desc":"famille d'entités \"période de caisse\""},
  {"id":"registrations","desc":"famille d'entités \"inscription\""},
  {"id":"relationships","desc":"famille \"lien entre deux contacts\""},
  {"id":"resources","desc":"famille d'entités \"capacité interne planifiable\""},
  {"id":"reviews","desc":"famille \"évaluation exprimée par un tiers\""},
  {"id":"routes","desc":"famille \"tournée planifiée\" (itinéraire d'arrêts ordonnés)"},
  {"id":"shifts","desc":"famille \"créneau de travail planifié\""},
  {"id":"shipments","desc":"famille \"mouvement physique de biens\""},
  {"id":"stocks","desc":"famille \"quantité disponible d'un article à un emplacement\""},
  {"id":"stockMovements","desc":"famille \"mouvement de stock\""},
  {"id":"subscriptions","desc":"famille \"engagement récurrent\""},
  {"id":"tasks","desc":"famille \"unité de travail interne\""},
  {"id":"tickets","desc":"famille \"demande entrante prise en charge\""},
  {"id":"timesheets","desc":"famille \"temps de travail\""},
  {"id":"todos","desc":"famille \"chose à faire\" (hors projet)"},
  {"id":"vouchers","desc":""},
  {"id":"warranties","desc":"famille \"couverture dans le temps\""},
  {"id":"workOrders","desc":"famille \"ordre de travail\" (travail technique concret)"},
  {"id":"workers","desc":"famille d'entités \"personne qui travaille pour l'organisation\""}
];

/**
 * Les 8 jeux de donnees declares par les apps de l'epoque (les `entities` de
 * leur fiche `taki.app.json`).
 * DEFAUT seulement : a l'execution, le serveur remplace cette table par `GET /api/apps`.
 *
 * UNE TABLE FIGEE, ET C'EST POUR CA QU'ELLE NOMME ENCORE INVENTAIRE ET PATISSERIE,
 * sorties du produit le 11/10/2026. L'ancienne forme d'une cible de champ lie,
 * `jeu:<index>`, est un RANG dans cette table (`cibleDeChampLie`,
 * `brief/derive.mjs`) : retirer une ligne ferait designer a un brief deja
 * enregistre un autre jeu que celui qu'il visait, sans rien dire. Les familles
 * de ces lignes (`assets`, `products`...) restent celles du socle.
 */
export const JEUX = [
  {"app":"Contact","appId":"contact","famille":"contacts","types":["person","organization"]},
  {"app":"Inventaire","appId":"inventaire","famille":"assets","types":["materiel"]},
  {"app":"Inventaire","appId":"inventaire","famille":"careRecords","types":["intervention"]},
  {"app":"Inventaire","appId":"inventaire","famille":"loans","types":["location"]},
  {"app":"Inventaire","appId":"inventaire","famille":"contacts","types":[]},
  {"app":"Pâtisserie","appId":"patisserie","famille":"products","types":["matiere-premiere","patisserie"]},
  {"app":"Pâtisserie","appId":"patisserie","famille":"contacts","types":["organization"]},
  {"app":"Pâtisserie","appId":"patisserie","famille":"compositions","types":["recette"]}
];

/**
 * Les natures de champ proposees au fondateur. `durée` est un nombre de MINUTES
 * que le socle ecrit en heures (`duree`, `packages/ui/src/views/habillages.ts`).
 * `e-mail`, `téléphone` et `lien web` sont les trois types de texte que le
 * fichier de champs distingue (`email`, `phone`, `url` dans
 * `packages/data-model/src/custom-field.ts`) : sans nature pour les dire, une
 * app qui les portait les voyait retomber en `text` a la reprise.
 */
export const NATURES = [
  "texte",
  "texte long",
  "e-mail",
  "téléphone",
  "lien web",
  "nombre",
  "prix",
  "pourcentage",
  "durée",
  "oui / non",
  "date",
  "date et heure",
  "liste de choix",
  "liste de choix multiple",
  "champ lié",
  "personne de l'organisation",
  "liste de textes"
];

/**
 * Les calculs offerts pour une stat, ranges par FAMILLE DE NATURE (le `familleDe` de V1, interne a `derive.mjs`).
 * La cle `aucun` est le cas "pas de champ choisi" : on ne sait que compter les fiches.
 */
export const CALCULS = {
  "aucun": [
    {"k":"nb","t":"Nombre de fiches"}
  ],
  "num": [
    {"k":"total","t":"Total"},
    {"k":"moyenne","t":"Moyenne"},
    {"k":"min","t":"Minimum"},
    {"k":"max","t":"Maximum"},
    {"k":"nbVide","t":"Nombre de fiches sans valeur"}
  ],
  "choix": [
    {"k":"nbVaut","t":"Nombre pour une valeur donnée","val":1},
    {"k":"nbDistinct","t":"Nombre de valeurs différentes"},
    {"k":"nbVide","t":"Nombre de fiches sans valeur"}
  ],
  "date": [
    {"k":"max","t":"La plus récente"},
    {"k":"min","t":"La plus ancienne"},
    {"k":"nbVide","t":"Nombre de fiches sans date"}
  ],
  "bool": [
    {"k":"nbVaut","t":"Nombre pour une réponse donnée","val":1},
    {"k":"nbVide","t":"Nombre de fiches sans réponse"}
  ],
  "lien": [
    {"k":"nbRempli","t":"Nombre de fiches liées"},
    {"k":"nbVide","t":"Nombre de fiches non liées"}
  ],
  "texte": [
    {"k":"nbRempli","t":"Nombre de fiches renseignées"},
    {"k":"nbVide","t":"Nombre de fiches sans valeur"}
  ]
};

/**
 * Les 8 champs que le SDK pose lui-meme sur chaque fiche.
 * `pick` a 0 = plomberie interne, jamais proposee a l'affichage.
 * `trace` a 1 = les CHAMPS DE TRACE (`CHAMPS_DE_TRACE`, data-model) : qui et
 * quand, poses par le socle, jamais saisis. Ils s'offrent sur la fiche en
 * lecture seule, jamais par defaut.
 */
export const STD = [
  {"k":"createdAt","nom":"Créé le","nature":"date et heure","pick":1,"trace":1,"note":"la date de création, posée par le SDK"},
  {"k":"updatedAt","nom":"Modifié le","nature":"date et heure","pick":1,"trace":1,"note":"la dernière modification"},
  {"k":"createdBy","nom":"Créé par","nature":"personne de l'organisation","pick":1,"trace":1,"note":"la personne qui a créé la fiche, affichée par son nom"},
  {"k":"updatedBy","nom":"Modifié par","nature":"personne de l'organisation","pick":1,"trace":1,"note":"la personne qui a modifié la fiche en dernier"},
  {"k":"archivedAt","nom":"Archivé le","nature":"date et heure","pick":1,"note":"vide tant que la fiche est active"},
  {"k":"id","nom":"Identifiant","nature":"texte","pick":1,"note":"technique et opaque, généré par Firestore"},
  {"k":"deletedAt","nom":"Supprimé le","nature":"date et heure","pick":0,"note":"plomberie interne, jamais affiché"},
  {"k":"schemaVersion","nom":"Version du schéma","nature":"nombre","pick":0,"note":"plomberie interne, jamais affiché"}
];

/**
 * Ceux des champs du socle qui sont des dates.
 */
/**
 * LES CHAMPS NATIFS COMMUNS AUX FAMILLES DU SOCLE, et leur mot francais.
 *
 * POURQUOI CETTE TABLE EXISTE : `STD` couvre les champs que le SDK pose sur tout
 * document (createdAt, updatedBy...). Elle ne couvre PAS ce que les familles
 * portent en propre : `name`, `status`, `reference`, `type`. Ces noms-la se
 * retrouvaient donc bruts dans les listes deroulantes du studio (« name (socle) »,
 * « status (socle) »), c'est-a-dire exactement ce que le fondateur a refuse :
 * « tu met des noms reel et non technique ».
 *
 * ELLE NE COUVRE QUE CE QUI EST PARTAGE. Un champ propre a une seule famille
 * (`ownerContactId`, `assigneeWorkerId`) n'a pas de mot ici : le studio le
 * montrera brut, et c'est honnete, parce qu'inventer « Contact proprietaire »
 * pour un champ qu'on n'a pas lu serait une traduction devinee.
 */
export const NATIFS = [
  {"k":"name","nom":"Nom"},
  {"k":"label","nom":"Libellé"},
  {"k":"status","nom":"Statut"},
  {"k":"reference","nom":"Référence"},
  {"k":"type","nom":"Type"},
  {"k":"email","nom":"E-mail"},
  {"k":"phone","nom":"Téléphone"},
  {"k":"firstName","nom":"Prénom"},
  {"k":"lastName","nom":"Nom de famille"},
  {"k":"priority","nom":"Priorité"},
  {"k":"source","nom":"Source"},
  {"k":"startAt","nom":"Début"},
  {"k":"endAt","nom":"Fin"},
  {"k":"dueAt","nom":"Échéance"}
];
/**
 * CE QUE LE SCRIPT NE SAIT PAS ECRIRE, FAMILLE PAR FAMILLE.
 *
 * DEUX TABLES, ET AUCUNE N'EST UNE OPINION : elles sont la SORTIE de
 * `natifsDeCreation` (`tools/studio-dev/moteur-app.mjs`), qui lit le SDK et le
 * data-model, rejouee sur les 58 familles du catalogue. Elles vivent ici parce
 * que le Studio tourne dans le NAVIGATEUR : il ne peut ni lire le depot ni
 * appeler cette fonction, et il doit pourtant DIRE la limite AVANT de
 * construire (consigne 11 du fondateur : « le bouton ne doit jamais dire pret
 * pour une chose que le script sait ne pas honorer »).
 *
 * ELLES NE PEUVENT PAS DERIVER EN SILENCE : `tests/limites.test.mjs` rejoue
 * `natifsDeCreation` sur tout le catalogue et compare, dans les DEUX sens. Une
 * famille qui devient creable, ou qui cesse de l'etre, rougit.
 *
 * `FAMILLES_SANS_CREATION` : le script ne sait ecrire AUCUN appel de creation
 * (la famille decrit son entree dans le SDK, ou le SDK ne l'expose pas).
 *
 * `NATIFS_QUI_POINTENT_UNE_FICHE` : la famille exige a la creation un champ qui
 * DESIGNE une autre fiche. Le formulaire le demande alors en identifiant BRUT
 * (« k3n8vX2pQr9 ») au lieu d'une liste ou l'on choisit « Boulangerie Martin ».
 * L'app se cree et s'ouvre : c'est une rusticite, pas une panne.
 *
 * `timesheets.workerId` N'Y EST PLUS : c'est une PERSONNE de l'organisation
 * (`personneId()`), choisie par son nom dans l'annuaire du socle, jamais un
 * identifiant brut.
 */
export const FAMILLES_SANS_CREATION = [
  {"id":"contacts","raison":"elle decrit sa creation dans le SDK, pas dans le data-model"},
  {"id":"member","raison":"le SDK ne l'expose pas"},
  {"id":"organization","raison":"le SDK ne l'expose pas"},
  {"id":"recurrences","raison":"un plan se tire d'une fiche ou d'un modèle (« Créer un plan récurrent ») : il cite un modèle, qui ne se saisit pas au formulaire"}
];

export const NATIFS_QUI_POINTENT_UNE_FICHE = [
  {"id":"absences","clefs":["workerId"]},
  {"id":"accessGrants","clefs":["granteeContactId"]},
  {"id":"agreements","clefs":["contactId"]},
  {"id":"attendances","clefs":["contactId"]},
  {"id":"compositions","clefs":["productId"]},
  {"id":"consents","clefs":["contactId"]},
  {"id":"invoices","clefs":["contactId"]},
  {"id":"loans","clefs":["itemAssetId","borrowerContactId"]},
  {"id":"lots","clefs":["productId"]},
  {"id":"orders","clefs":["contactId"]},
  {"id":"registerSessions","clefs":["placeId"]},
  {"id":"registrations","clefs":["eventId","contactId"]},
  {"id":"relationships","clefs":["fromContactId","toContactId"]},
  {"id":"shifts","clefs":["workerId"]},
  {"id":"stocks","clefs":["productId","placeId"]},
  {"id":"stockMovements","clefs":["productId"]},
  {"id":"subscriptions","clefs":["contactId"]}
];

export const STD_DATES = [
  "createdAt",
  "updatedAt",
  "archivedAt",
  "deletedAt"
];

/**
 * Les 5 vues du socle. `core.liste` est le repli universel, `core.fiche` le detail.
 */
export const VUES = [
  {"id":"core.liste","label":"Liste","note":"repli universel, jamais grisée"},
  {"id":"core.tableau","label":"Tableau","note":"comparer des valeurs ; seule vue qui permet d'agir sur plusieurs lignes"},
  {"id":"core.kanban","label":"Kanban","note":"seule vue où l'on déplace un élément au geste"},
  {"id":"core.calendrier","label":"Calendrier","note":"lecture seule, on ne déplace rien"},
  {"id":"core.fiche","label":"Fiche","note":"le détail d'un élément, modifiable sur place"}
];

/**
 * Les 7 types d'automatisation. `ok` a 0 = le socle ne sait pas encore le faire,
 * `pq` dit pourquoi, et c'est cette phrase que lit le fondateur.
 *
 * `notif` N'EST PLUS OFFERT, ET IL RESTE ICI. Les notifications sont sorties des
 * automatisations pour devenir une section a elles
 * (`brief-ui/notifications.tsx`), donc le selecteur ne les propose plus
 * (`TYPE_RETIRE_DES_AUTOMATISATIONS`). L'entree, elle, ne se supprime pas : un
 * brief deja sauve peut porter `extra[].type === 'notif'`, et `xtype()` retombe
 * sur le PREMIER type quand il ne trouve pas -- la ligne afficherait alors
 * « Automatisme au geste » en stockant `notif`, un mensonge silencieux. Sa
 * phrase de refus sert aussi, telle quelle, au prompt (bloc des notifications).
 */
export const XTYPES = [
  {"k":"auto","t":"Automatisme au geste","d":"se déclenche quand quelqu'un fait quelque chose à l'écran","ok":1},
  {"k":"api","t":"Appel à un service extérieur","d":"une API tierce, donc une clef, donc une Cloud Function","ok":0,"pq":"une clef d'API dans un bundle est publique : elle se lit dans l'onglet réseau. Ça exige une Function, donc une branche core/."},
  {"k":"notif","t":"Notification","d":"un mail, une alerte, un rappel","ok":0,"pq":"rien n'envoie de mail aujourd'hui. Chantier notif-mail-firebase, à l'état d'idée."},
  {"k":"planif","t":"Tâche planifiée","d":"à heure fixe, sans personne devant l'écran","ok":0,"pq":"une tâche planifiée existe dans le socle (passage quotidien des plans récurrents, `docs/FUNCTIONS.md`) ; un autre rythme ou une autre action reste une branche core/."},
  {"k":"event","t":"Réaction à un changement","d":"quand une fiche bouge, faire quelque chose ailleurs","ok":0,"pq":"aucun déclencheur Firestore n'existe : zéro onDocumentWritten. Les events et extension points sont une intention du playbook, sans une ligne de code."},
  {"k":"io","t":"Import ou export","d":"un fichier qui entre ou qui sort","ok":0,"pq":"rien n'est prévu pour ça aujourd'hui."},
  {"k":"autre","t":"Autre","d":"","ok":0,"pq":"à qualifier."}
];

/**
 * Le type que « Automatisations » ne propose plus : il a sa propre section.
 * Une clef, pas une phrase, pour que personne n'ait a reconnaitre un libelle.
 */
export const TYPE_RETIRE_DES_AUTOMATISATIONS = 'notif';

/**
 * Les 7 portees d'une porte, dans l'ordre du formulaire : [cle, libelle].
 *
 * `jd` EN EST SORTIE. Le jeu de donnees n'est plus une sous-section d'une porte :
 * il vit a la racine du brief (`brief.jeux[]`) et une porte le DESIGNE.
 */
export const PSEC = [
  ["pd","Porte"],
  ["vu","Vues"],
  ["vb","Détail par vue"],
  ["fi","Fiche"],
  ["ft","Filtres et tri"],
  ["ac","Actions"],
  ["st","Stats"]
];

/**
 * Les 3 apps connues, deduites de JEUX (`[...new Set(JEUX.map(j => j.app))]`).
 * DEFAUT seulement, comme JEUX. Le Cockpit n'y figure pas : outil interne, il ne
 * declare aucun jeu de donnees.
 */
export const APPS = [
  "Contact",
  "Inventaire",
  "Pâtisserie"
];
